<template>
  <div>
    <v-app>
      <!-- DeskTop -->
      <div class="background">
        <v-system-bar height="50px" style="background: rgba(0,0,0,0.2)" class="mb-5">
          <v-row no-gutter>
            <!-- <v-col md="2" lg="1"></v-col> -->
            <v-col md="3" lg="5"></v-col>
            <v-col md="7" lg="6">
              <v-list-item>
                <v-row no-gutters class="text-white">
                  <!-- @click="PrivacyNotice()"
              @click="SecurityPolicy()"
              @click="TermsofSercice()" -->
                  <v-col cols="3" md="3" lg="3" class="pt-3" style="cursor: pointer;" @click="PrivacyNotice()">
                    <v-icon color="white" style="font-size: 1.25em;">mdi-shield-lock</v-icon>
                    Privacy Notice
                  </v-col>
                  <v-col cols="4" md="4" lg="4" class="pt-3" style="cursor: pointer;" @click="SecurityPolicy()">
                    <v-icon color="white" style="font-size: 1.25em;">mdi-shield-key-outline</v-icon>
                    Information SecurityPolicy
                  </v-col>
                  <v-col cols="3" md="3" lg="3" class="pt-3" style="cursor: pointer;" @click="TermsofSercice()">
                    <v-icon color="white" style="font-size: 1.25em;">mdi-file-document-outline</v-icon>
                    Terms of Sercice
                  </v-col>
                  <v-col cols="2" md="2" lg="2">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                            <v-list-item-content style="cursor: pointer;">
                              <v-list-item-title v-bind="{ ...attrs, ...tooltipAttrs }" v-on="{ ...on, ...tooltipOn }" class="text-white">
                                <v-icon color="white" style="font-size: 1.25em;">mdi-folder-wrench-outline</v-icon>
                                {{ $t("loginpage.Instruction") }}</v-list-item-title>
                            </v-list-item-content>
                          </template>
                          <span>{{ $t("loginpage.Instruction") }}</span>
                        </v-tooltip>
                      </template>
                      <v-list>
                        <!-- @click="downloadAdmin"
                  @click="downloadAttendee"
                  @click="downloadVote" -->
                        <v-list-item @click="downloadAdmin" style="cursor: pointer;">
                          <v-list-item-title>1.{{ $t("loginpage.Organizers") }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="downloadAttendee" style="cursor: pointer;">
                          <v-list-item-title>2.{{ $t("loginpage.participant") }}</v-list-item-title>
                        </v-list-item>
                        <!-- <v-list-item @click="downloadVote" style="cursor: pointer;">
                          <v-list-item-title>3.{{ $t("loginpage.votesystem") }}</v-list-item-title>
                        </v-list-item> -->
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-col>
            <v-col md="1" lg="1" sm="2" xs="1">
              <div class="mt-1">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item-content style="cursor: pointer;">
                      <v-list-item-title v-bind="attrs" v-on="on" class="text-white">
                        <v-icon color="white" style="font-size: 1.2em;" class="mt-n1">mdi-web</v-icon>
                        <span> {{ $t("default") == 'th' ? 'TH' : 'EN' }}</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-list>
                    <v-list-item @click="change_languae('th')">
                      <v-img src="@/assets/th.jpg" max-width="18px" max-height="18px"></v-img>
                      <span>ไทย</span>
                    </v-list-item>
                    <v-list-item @click="change_languae('en')">
                      <v-img src="@/assets/en.png" max-width="16px" max-height="16px"></v-img>
                      English
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
        </v-system-bar>
        <register v-if="conditionShowComponent" />
        <Login v-if="!conditionShowComponent" />
      </div>
      <!-- Mobile -->
      <div class="backgroundmobile">
        <v-system-bar height="50px" style="background: rgba(0,0,0,0.35)" class="mb-5">
          <v-row no-gutter>
            <v-col md="9" lg="9" sm="9" xs="9"></v-col>
            <!-- <v-col md="3" lg="5" sm="3" xs="2">
              <div class="text-center" background-color="transparent">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-content style="cursor: pointer;">
                    <v-list-item-title v-bind="attrs" v-on="on" class="text-white">
                      <v-icon color="white" style="font-size: 1.25em;"
                  >mdi-folder-wrench-outline</v-icon>
                      คู่มือการใช้งาน</v-list-item-title >
                  </v-list-item-content>  
                </template>
                <v-list>
                  <v-list-item style="cursor: pointer;">
                    <v-list-item-title @click="downloadAdmin">1.คู่มือการใช้งานสำหรับผู้จัดการประชุม</v-list-item-title>
                  </v-list-item>
                  <v-list-item style="cursor: pointer;">
                    <v-list-item-title @click="downloadAttendee">2.คู่มือการใช้งานสำหรับผู้ร่วมประชุม</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            </v-col> -->
            <v-col md="1" lg="5" sm="1" xs="1">
              <div class="">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item-content style="cursor: pointer;">
                      <v-list-item-title v-bind="attrs" v-on="on" class="text-white">
                        <v-icon color="white" style="font-size: 1.25em;">mdi-format-list-checkbox</v-icon>
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-list>
                    <v-list-item>
                      <v-list-item-title @click="PrivacyNotice()">
                        <v-icon color="red" style="font-size: 1.25em;">mdi-shield-lock</v-icon>
                        Privacy Notice
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title @click="SecurityPolicy()">
                        <v-icon color="red" style="font-size: 1.25em;">mdi-shield-key-outline</v-icon>
                        Information Security Policy
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title @click="TermsofSercice()">
                        <v-icon color="red" style="font-size: 1.25em;">mdi-file-document-outline</v-icon>
                        Terms of Sercice
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title class="text-center">
                        <v-icon color="#000000" style="font-size: 1.25em;">mdi-folder-wrench-outline</v-icon>
                        {{ $t("loginpage.Instruction") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item style="cursor: pointer;">
                      <v-list-item-title @click="downloadAdmin">
                        <li>1. {{ $t("loginpage.Organizers") }}</li>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item style="cursor: pointer;">
                      <v-list-item-title @click="downloadAttendee">
                        <li>2. {{ $t("loginpage.participant") }}</li>
                      </v-list-item-title>
                    </v-list-item>
                    <!-- <v-list-item style="cursor: pointer;">
                      <v-list-item-title @click="downloadVote">3.{{ $t("loginpage.votesystem") }}</v-list-item-title>
                    </v-list-item> -->
                  </v-list>
                </v-menu>
              </div>
            </v-col>
            <v-col md="2" lg="5" sm="2" xs="1">
              <div class="">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item-content style="cursor: pointer;">
                      <v-list-item-title v-bind="attrs" v-on="on" class="text-white">
                        <v-icon color="white" style="font-size: 1.25em;">mdi-web</v-icon>
                        <span class="mt-n12"> {{ $t("default") == 'th' ? 'TH' : 'EN' }}</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-list>
                    <v-list-item @click="change_languae('th')">
                      <v-img src="@/assets/th.jpg" max-width="18px" max-height="18px"></v-img>
                      <span>ไทย</span>
                    </v-list-item>
                    <v-list-item @click="change_languae('en')">
                      <v-img src="@/assets/en.png" max-width="16px" max-height="16px"></v-img>
                      English
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
        </v-system-bar>
        <div class="mt-16 pt-3">
          <LoginMobile v-if="!conditionShowComponent" />
          <register v-if="conditionShowComponent" />
        </div>
      </div>
      <Footer />
      <!-- cookie-law -->
      <div id="app">
        <cookie-consent v-if="!cookiesAccepted" @accept="handleAccept" @open-settings="openSettingsDialog" />
        <cookie-settings-dialog v-if="showSettingsDialog" @close="showSettingsDialog = false" />
      </div>
      <!-- <cookie-law theme="dark-lime" style="opacity:0.9; flex-flow: none;">
        <div slot-scope="props" style="padding:10px; width: 100%;">
          <v-row no-gutters>
            <v-col
              cols="12"
              md="8"
              sm="12"
              xs="12"
              align="center"
              class="mb-4 pt-1"
              style="font-size: 14pt;"
            >
            {{$t("Homepage.cookie") }}
            </v-col>
            <v-col
              cols="12"
              md="2"
              sm="6"
              xs="6"
              align="right"
              class="mb-2"
              v-show="!$vuetify.breakpoint.mobile"
            >
              <v-btn @click="props.close" x-large color="#942929"
                ><span style="color:white;">{{$t("button.btnreject") }}</span></v-btn
              >
            </v-col>
            <v-col
              cols="12"
              md="2"
              sm="6"
              xs="6"
              align="center"
              class="mb-2"
              v-show="$vuetify.breakpoint.mobile"
            >
              <v-btn @click="props.close" x-large color="#942929"
                ><span style="color:white;">{{$t("button.btnreject") }}</span></v-btn
              >
            </v-col>
            <v-col cols="12" md="2" sm="6" xs="6" align="center">
              <v-btn @click="props.accept" x-large color="#8eff59"
                ><span style="font-weight:bold;">{{$t("button.btnACCEPT") }}</span></v-btn
              >
            </v-col>
          </v-row>
        </div>
      </cookie-law> -->
    </v-app>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Login from "../components/Login/Login";
import LoginMobile from "../components/Login/LoginMobile.vue";
// import Login from '../components/Login/Login.vue'
import CookieLaw from "vue-cookie-law";
import register from "../components/Login/register.vue";
import Footer from '../components/Footer.vue';
// cookie-law
import CookieConsent from '../components/CookieConsent.vue';
import CookieSettingsDialog from '../components/CookieSettingsDialog.vue';


export default {
  data() {
    return {
      cookiesAccepted: localStorage.getItem('cookiesAccepted') === 'true',
      cookiePreferences: localStorage.setItem('cookiePreferences', JSON.stringify({
        performance: false,
        targeting: false,
      })),
      showSettingsDialog: false,
    };
  },
  components: {
    Login,
    // CookieLaw,
    Footer,
    LoginMobile,
    register,
    CookieConsent,
    CookieSettingsDialog,
  },
  created() {
  },
  computed: {
    ...mapState("dialog", ["switchSigninSignup"]),
    conditionShowComponent: {
      get() {
        return this.switchSigninSignup;
      },
      set(value) {
        this.setSwitchSignSignup(value);
      }
    }
  },
  methods: {
    handleAccept() {
      this.cookiesAccepted = true;
      localStorage.setItem('cookiesAccepted', 'true');
    },
    openSettingsDialog() {
      this.showSettingsDialog = true;
    },
    ...mapActions("dialog", ["setSwitchSignSignup"]),
    joinpage() {
      this.$router.push({ path: '/joinpage' }).catch(() => { })
    },
    PrivacyNotice() {
      window.open(
        process.env.VUE_APP_POLICIES + '?' + 'tabs=' + 1,
        "_blank"
      );
    },
    change_languae(language) {
      // console.log(language);
      if (language === "th") {
        localStorage.setItem("lang", "th")
        this.$i18n.locale = "th"
      } else if (language === "en") {
        localStorage.setItem("lang", "en")
        this.$i18n.locale = "en"
      }
    },
    SecurityPolicy() {
      window.open(
        process.env.VUE_APP_POLICIES + '?' + 'tabs=' + 2,
        "_blank"
      );
    },
    TermsofSercice() {
      window.open(
        process.env.VUE_APP_POLICIES + '?' + 'tabs=' + 0,
        "_blank"
      );
    },
    async downloadAdmin() {
      try {
        await this.axios
          .get(process.env.VUE_APP_API + '/api/lv1/activity/downloadbusiness', {
            responseType: 'arraybuffer'
          })
          // .get(process.env.VUE_APP_API + '/api/lv1/download/manualBusiness', {
          //   responseType: 'arraybuffer'
          // })
          .then(res => {
            const blob = new Blob([res.data], { type: 'application/pdf' })
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'Manual_One_Conference_Service_Business.pdf'
            link.click()
          })
      } catch (error) {
        console.log('Manual_One_Conference_Service_Business', error)
      }
    },
    async downloadAttendee() {
      try {
        await this.axios
          .get(process.env.VUE_APP_API + '/api/lv1/activity/downloadcitizen', {
            responseType: 'arraybuffer'
          })
          // .get(process.env.VUE_APP_API + '/api/lv1/download/manualCitizen', {
          //   responseType: 'arraybuffer'
          // })
          .then(res => {
            const blob = new Blob([res.data], { type: 'application/pdf' })
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'Manual_One_Conference_Service_Citizen.pdf'
            link.click()
          })
      } catch (error) {
        console.log('ManualAttendeeBusiness', error)
      }
    },
    async downloadVote() {
      try {
        await this.axios
          .get(process.env.VUE_APP_API + '/api/v1/download/manualVote', {
            responseType: 'arraybuffer'
          })
          .then(res => {
            const blob = new Blob([res.data], { type: 'application/pdf' })
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'Manual_One_Conference_Service_Vote.pdf'
            link.click()
          })
      } catch (error) {
        console.log('ManualAttendeeBusiness', error)
      }
    },
  }
};
</script>

<style scoped>
.background {
  background-image: url("~@/assets/fram_bg.jpg");
  background-position: right;
  transform: translate(1px, 0px);
  height: 100%;
  width: 100%;
  /* left: 100%; */
  background-repeat: no-repeat;
  background-size: cover;
}

.backgroundmobile {
  background-image: linear-gradient(to right,
      #1cd49d,
      #20c492,
      #0bb09a,
      #0baabd,
      #03429e);
  height: 100%;
  width: 100%;
  /* left: 100%; */
  background-repeat: no-repeat;
  background-size: cover;
}

@media screen and (max-width: 960px) {
  .background {
    display: none;
  }
}

@media screen and (min-width: 961px) {
  .backgroundmobile {
    display: none;
  }
}

.bgMobile {
  object-position: left top;
  transform: translate(0px, 0px);
  background-repeat: no-repeat;
  background-size: cover;
  left: 0%;
  bottom: 5%;
  /* top: 10%; */
}

.logomobile {
  object-position: right top;
  transform: translate(0px, 0px);
  background-repeat: no-repeat;
  background-size: cover;
  left: 12%;
  /* bottom: 50%; */
  top: 0%;
  width: 90%;
}
</style>
